module.exports = __webpack_public_path__ + "static/media/klimbingkiosk2.72ed1098.png";